import React from 'react';

export function StoreMap({ stores = [], selectedStore, onSelect, className = '', ...props }) {
  // Placeholder for real map integration (e.g., Mapbox, Google Maps)
  return (
    <div className={`w-full h-80 bg-gradient-to-br from-accent/10 to-background border border-border rounded-2xl shadow-lg flex items-center justify-center ${className}`} {...props}>
      <span className="text-accent text-2xl font-heading">[Map Integration Coming Soon]</span>
    </div>
  );
}

export default StoreMap;
